import { useIntl } from 'react-intl';
import { LabelText, TooltipContainer, ValueText } from './styles';

export interface CustomTooltipProps {
  active?: boolean;
  payload?: { value: number }[];
  label?: string;
  minorCurrency: string;
  minorPrecision: number;
}

const CustomTooltipElement = ({
  active,
  payload,
  label,
  minorCurrency,
  minorPrecision,
}: CustomTooltipProps): JSX.Element | null => {
  const { formatNumber } = useIntl();

  if (!active || !payload || !label) return null;
  const { value = 0 } = payload[0];
  const formattedValue = formatNumber(value, {
    minimumFractionDigits: 2,
    maximumFractionDigits: minorPrecision,
  });
  return (
    <TooltipContainer>
      <ValueText>
        {formattedValue} {minorCurrency.toUpperCase()}
      </ValueText>
      <LabelText>{label}</LabelText>
    </TooltipContainer>
  );
};

export default CustomTooltipElement;
